import { jsx as _jsx } from "react/jsx-runtime";
import { Chip, Tooltip } from '@mui/material';
import { useState } from 'react';
import { useTranslation } from '@zurich/common/hooks';
export const ChipWithCopy = ({ chipLabelValue, onDelete, className, disabled = false, }) => {
    const { t } = useTranslation();
    const [isValueCopied, setIsValueCopied] = useState(false);
    const tooltipTitle = isValueCopied ? t('common:copied') : t('common:copy');
    const handleChipClick = async () => {
        await navigator.clipboard.writeText(chipLabelValue);
        setIsValueCopied(true);
        setTimeout(() => {
            setIsValueCopied(false);
        }, 1000);
    };
    return (_jsx(Tooltip, { title: tooltipTitle, arrow: true, placement: "bottom", children: _jsx(Chip, { className: className, label: chipLabelValue, onClick: handleChipClick, onDelete: onDelete, disabled: disabled }) }));
};
